import { createDeviceDataFromResources } from './deviceData';
import { getDeviceResources } from './deviceResources';
// Demo device (ABC1234E) — used to showcase the app without a physical NFC tag,
// e.g. for the Apple review. Produces data that already satisfies IDeviceData.
export const DEMO_DEVICE_CODE = 'ABC1234E';
/** Build the demo device data (ABC1234E) in the IDeviceData format. */
export function createDemoDeviceData(uri) {
    return createDeviceDataFromResources(getDeviceResources(DEMO_DEVICE_CODE), { uri, source: 'demo' });
}
